import styled, { css } from "styled-components";
import { primaryColor } from "../../pages/dash/styles";

export const ActionsFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 20px 30px;
  border-top: 1px solid #ebeef2;
  bottom: 0;
`;

export const CancelButton = styled.button`
  background: none;
  color: #566474;
  border: 1px solid #ebeef2;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  height: 48px;
  width: 170px;
`;

export const SaveButton = styled.button`
  background-color: ${primaryColor};
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  height: 48px;
  width: 170px;
  transition: background-color 0.2s;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background-color: #356de3;
  }
`;
